/**
 * sampleFlowData.ts
 *
 * Shared sample dataset for the onboarding "Try Sample Data" feature.
 * Imported by both FlowSidebar.tsx (sidebar quick-load button) and
 * FileSourceNodeConfig.tsx (in-node config panel button).
 *
 * Keeping it here avoids duplication and makes it easy to update
 * the sample rows in one place.
 */

/** 10-row sales CSV with Date, Product, Region, Sales, Units columns. */
export const SAMPLE_CSV = `Date,Product,Region,Sales,Units
2024-01-01,Widget A,North,1200,24
2024-01-01,Widget B,South,800,16
2024-01-02,Widget A,East,950,19
2024-01-02,Widget C,West,1500,30
2024-01-03,Widget B,North,670,13
2024-01-03,Widget A,South,1100,22
2024-01-04,Widget C,East,1350,27
2024-01-04,Widget B,West,720,14
2024-01-05,Widget A,North,1400,28
2024-01-05,Widget C,South,980,20`;

/** File name used when uploading the sample data. */
export const SAMPLE_FILE_NAME = 'sample_sales_data.csv';

/**
 * Builds a native File object from SAMPLE_CSV.
 * Pass the result directly to any upload handler that accepts a File.
 */
export function buildSampleFile(): File {
  const blob = new Blob([SAMPLE_CSV], { type: 'text/csv' });
  return new File([blob], SAMPLE_FILE_NAME, { type: 'text/csv' });
}
